export default __webpack_public_path__ + "static/media/customer_3.fca6e1c9.png";